import dayjs from 'dayjs';
import { DATE_FORMAT_FULL } from '../const/system';



export const toUtcString = (value) => value ? dayjs.utc(value).format(DATE_FORMAT_FULL) : null;

export const fromUtcString = (value) => value ? dayjs.utc(value) : null;
